/**
 * Created by cc on 2016/10/20 0020.
 */
'use strict';
import Flow from 'eme-flow';
export default {
    /**
     * 显示流程
     * @param req
     * @param res
     */
    showFlow: async function (req, res) {
        try {
            await Flow.showFlow(req, res);
        }catch(e){
            res.serverError(e);
        }
    },
    /**
     * 处理流程
     * @param req
     * @param res
     */
    doFlow: async function (req, res) {
        try {
            let instance_id = await Flow.doFlow(req, res);
            if (req.wantsJSON) {
                if (req.options.jsonp && !req.isSocket) {
                    return res.jsonp(instance_id);
                } else if (req.param('callback')) {
                    return res.jsonp(instance_id);
                } else return res.json(instance_id);
            } else {
                return res.redirect('/flow/show.html?instance_id=' + instance_id + '&from_page=' + req.param('from_page'));
            }
        } catch (e) {
            res.serverError(e);
        }
    }
}
module.exports = exports.default;